<div class="modal-container-custom">
  <div class="modal-content-custom viewDocsStyle_1">
    <ngb-carousel #carousel *ngIf="docsToView.length" [animation]="false">
      <ng-template ngbSlide *ngFor="let doc of docsToView; first as isFirst; last as isLast">
        <div class="modal-header">
          <button type="button" id="close-docs-view-modal" class="close" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="row d-flex align-items-center">
            <div class="col-md-3">
              <button class="doc-nav-button"  id="show-previous-doc" (click)="carousel.prev()" *ngIf="!isFirst">< Prev</button>
            </div>
            <div class="col-md-6">
              <div>
                <h4 id={{doc.id}} class="modal-title enabled-text">{{doc.title}}</h4>
              </div>
              <div id={{doc.additionalData}} *ngIf="doc.additionalData">{{doc.additionalData}}</div>
            </div>
            <div class="col-md-3">
              <button id="show-next-doc" class="doc-nav-button" (click)="carousel.next()" *ngIf="!isLast">Next ></button>
            </div>
          </div>
        </div>
        
        <embed id="pdf-doc-embed-{{doc.id}}" [attr.src]="doc.sanitizedUrl" width="100%" height="675px" type="application/pdf">
      </ng-template>
    </ngb-carousel>
  </div>
</div>
